export default "/images/6c7170e1cf87561ab7aacb44465ecde8.png";